/* eslint-disable import/prefer-default-export */
import { easyPost } from './utils';


// 用户权益列表
export const getVipDetailList = easyPost('aries.vip.userPropertyList');

/**
 * 详情页会员基本信息
 * @see  https://yapi.hellobike.cn/project/2619/interface/api/185799
 */
export const getVipStatus = easyPost('aries.vip.userVipInfoSearch');

// 用户商品权益列表
export const userGoodsPropertyList = easyPost('aries.vip.userGoodsPropertyList');

// 开通/续费 页查询
export const vipGoodsInfo = easyPost('aries.vip.vipGoodsInfo');

// 付费会员缴费记录
export const searchUserVipOrder = easyPost('aries.vip.order.searchUserVipOrder');

// 付费会员缴费详情
export const queryOrderDetail = easyPost('aries.vip.order.queryOrderDetail');

// 购买付费会员
export const buyVipGoods = easyPost('aries.vip.order.buyVipGoods');


export const receiveVipCoupon = easyPost('aries.vip.receiveProperty');

// 确认权益
export const confirmProperty = easyPost('aries.vip.confirmProperty');

// 费会员订单状态查询
export const tryTakeOrderStatus = easyPost('aries.vip.order.tryTakeOrderStatus');

export const getVipGoodsV2 = easyPost('aries.vip.userNewGoodsPropertyList');

export const getUserPropert2 = easyPost('aries.vip.newUserPropertyList');

export const getUserVipStatusV2 = easyPost('new.mytab.config.vipData');

export const getWaitPayOrder = easyPost('aries.vip.order.getWaitPayOrder');

export const closeVipGoods = easyPost('aries.vip.order.closeVipGoods');

// 开通状态下获取续卡权益
export const getBenifitsInReopen = easyPost('aries.vip.reOpenGoodsPropertyWithinValid');

// 超级会员

// export const getSuperVipGoods = easyPost('aries.vip.userThirdGoodsPropertyList');

export const getSuperVipGoods = easyPost('aries.vip.multiGoods');
/** 已开卡
 * @see https://yapi.hellobike.cn/project/2619/interface/api/354077
 * */
export const getSuperUserPropert = easyPost('aries.vip.thirdUserPropertyList');

/** 获取奖励金任务列表
 * @see https://yapi.hellobike.cn/project/2619/interface/api/275177
 */
export const getTaurusAward = easyPost('aries.vip.getTaurusAward');
// 批量领取任务奖励
export const batchReceiveTaskAward = easyPost('aries.vip.batchReceiveTaskAward');

// 奖励金签到
export const doSignTaskAward = easyPost('aries.vip.doSignTaskAward');

// 是否展示反馈入口
export const isShowFeedback = easyPost('aries.vip.showFeedback');

// 是否展示反馈入口
export const submitFeedback = easyPost('aries.vip.submitFeedback');

// 是否展示qa
export const showQa = easyPost('aries.vip.qa.get');

/**
 * 已开卡页面弹窗
 * @see https://yapi.hellobike.cn/project/2619/interface/api/317669
 */
export const openWindow = easyPost('aries.vip.openedPopupWindows', { risk: true });

// 取消订阅付款详情
export const userVipSignInfoSearch = easyPost('aries.vip.userVipSignInfoSearch');
// 会员详情页 取消签约
export const cancelSignIn = easyPost('aries.vip.order.cancelSignIn');
// 查询退费周期权益使用信息
export const getCancelUserVipPropInfo = easyPost('aries.vip.getCancelUserVipPropInfo');
// 用户手动关闭续费
export const userCancelVip = easyPost('aries.vip.userCancelVip');
// 奖励金任务
export const specialBonusTask = easyPost('aries.vip.specialBonusTask');
/**
 * @description 提交场景疲劳度
 * @see https://yapi.hellobike.cn/project/2619/interface/api/349277
 * @param {Object} scene = rideCardEnableTips
 */
export const submitTired = easyPost('aries.vip.submitTired');
// 促劵核销玩法确认置换
export const propertyReplacement = easyPost('aries.vip.propertyReplacement');
// 膨胀玩法2列表
export const queryTransitionRecord = easyPost('aries.vip.queryTransitionRecord');
/**
 * 获取单单返任务详情
 * @see https://yapi.hellobike.cn/project/2619/interface/api/352009
 */
export const getTaskAwardDetail = easyPost('aries.vip.getTaskAwardDetail');
// 领取领取开卡礼权益
export const receiveTakeBonus = easyPost('aries.vip.receiveTakeBonus');
// 新版左右tab超级会员主接口 未开卡
export const unOpenedMultiVersion = easyPost('aries.vip.getUnOpenedMultiVersion');
// 新版本判断已开卡还是未开卡
export const getRedirectUrl = easyPost('aries.vip.getRedirectUrl');
// 新版本左右tab超级会员主接口 已开卡
export const openedMultiVersion = easyPost('aries.vip.openedMultiVersion');
// 聚合版本请求
export const aggGoods = easyPost('aries.vip.AggGoods');
// 查询用户信息 昵称
export const getUserNickName = easyPost('aries.vip.query.user.info');
// 获取签约渠道
export const getSignChannels = easyPost('aries.vip.getSignChannels');
// 抽奖模块 获取中奖记录列表
export const getLotteryRecord = easyPost('aries.vip.getLotteryRecord');
// 抽奖模块 获取我获得的列表
export const getUsersWinningPrizes = easyPost('aries.vip.getUsersWinningPrizes');
// 抽奖模块 顶部轮播列表
export const getlotteryLeadInfo = easyPost('aries.vip.getlotteryLeadInfo');
// 抽奖模块 中奖公示列表
export const getWinningAnnouncement = easyPost('aries.vip.getWinningAnnouncement');
// 抽奖模块 参与抽奖
export const joinLottery = easyPost('aries.vip.participationLotteryActivity', { risk: true });
/**
 * 活动通知push
 * @see https://yapi.hellobike.cn/project/2619/interface/api/382414
 */
export const lotteryPushNotify = easyPost('aries.vip.lotteryNotify');
// 查询抽奖活动
export const getLotteryActivity = easyPost('aries.vip.getLotteryActivity');

// 超级会员主接口新版 未开卡
export const getUnOpenSuperVip = easyPost('aries.vip.getUnOpenedVersionInfo');

// 超级会员主接口新版 已开卡
export const getOpenedSuperVip = easyPost('aries.vip.getOpenedVersionInfo');
